import { IconQuestionMarkCircle } from '@chilipiper/icons/figma-generated/src/icon'
import {
  Icon6Sense,
  IconBombora,
  IconChiliPiper,
  IconLeadfeeder,
  IconLiftai,
} from '@chilipiper/icons/figma-generated/src/logo'
import type { DeanonymizationProvider } from './types'

const providerIcons: Readonly<Record<string, React.ComponentType>> = {
  '6Sense': Icon6Sense,
  Bombora: IconBombora,
  ChiliPiper: IconChiliPiper,
  Leadfeeder: IconLeadfeeder,
  LiftAi: IconLiftai,
}

export const getProviderIcon = (provider: DeanonymizationProvider) =>
  providerIcons[provider] ?? IconQuestionMarkCircle

export const withTimeout = <T>(promise: Promise<T>, ms: number, message: string): Promise<T> =>
  new Promise((resolve, reject) => {
    const id = setTimeout(() => reject(new Error(message)), ms)
    promise.then(
      val => {
        clearTimeout(id)
        resolve(val)
      },
      err => {
        clearTimeout(id)
        reject(err)
      }
    )
  })
